/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFocusEffect} from '@react-navigation/native';
import dayjs from 'dayjs';
import React, {useCallback, useEffect} from 'react';
import {Platform, ScrollView, View} from 'react-native';
import {BoxShadowed} from '../../../components/AssuranceVoyage';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';

import {ValidationModification} from '../../../../common/utils/validationAssuranceVoyage';
import {voyage} from '../../../../data/constants/voyage';
import {useForm} from '../../../../hooks/AssuranceVoyage/useFormModification';
import SubmitButtons from '../../../components/Button/SecondaryButton';
import {InputField} from '../../../components/Inputs/InputField';
import {InputImage} from '../../../components/Inputs/InputImage';
import {InputPhoneNumber} from '../../../components/Inputs/InputPhoneNumber';
import Label from '../../../components/Label';

export const Form = (props: any) => {
  const {data, onCancelForm, onSubmitForm} = props;

  const {
    handleChange,
    handleSubmit,
    handleCancel,
    values,
    errors,
    showErrors,
    dto,
    handleChangeAssured,
    handleInitValues,
  } = useForm(data, ValidationModification, onCancelForm, handleSave);

  function handleSave() {
    onSubmitForm(dto.data);
  }

  useEffect(() => {
    console.log('values', values);
  }, [values]);

  useFocusEffect(
    React.useCallback(() => {
      handleInitValues();
    }, []),
  );

  const getMinDateFin = useCallback(() => {
    return values.dateDebut
      ? (typeof values.dateDebut == 'string'
          ? dayjs(values.dateDebut, 'DD/MM/YYYY')
          : dayjs(values.dateDebut)
        )
          .add(1, 'day')
          .toDate()
      : dayjs().add(2, 'day').toDate();
  }, [values.dateDebut]);

  const getMaxDateFin = useCallback(() => {
    return values.dateDebut
      ? (typeof values.dateDebut == 'string'
          ? dayjs(values.dateDebut, 'DD/MM/YYYY')
          : dayjs(values.dateDebut)
        )
          .add(
            (data.category || ('' as string))
              .toLowerCase()
              .includes(voyage.keyPelerinage.toLowerCase())
              ? 29
              : 179,
            'day',
          )
          .toDate()
      : dayjs().add(181, 'day').toDate();
  }, [values.dateDebut]);

  return (
    <View style={{paddingTop: 10, flex: 1}}>
      <ScrollView
        style={[Platform.OS === 'web' ? {paddingHorizontal: 20} : {}]}>
        <InputDatePicker
          label={'Date de couverture (debut)'}
          required
          value={values.dateDebut}
          name="dateDebut"
          onChange={handleChange}
          error={errors.dateDebut}
          showError={showErrors.dateDebut}
          dateMin={dayjs().add(2, 'day').toDate()}
        />
        <InputDatePicker
          label={'Date de couverture (fin)'}
          required
          value={values.dateFin}
          name="dateFin"
          onChange={handleChange}
          error={errors.dateFin}
          showError={showErrors.dateFin}
          dateMin={getMinDateFin()}
          dateMax={getMaxDateFin()}
          isEditable={!!values.dateDebut}
        />
        {values.assure.length
          ? values.assure.map(assure => (
              <BoxShadowed key={`${assure.id}`}>
                <Label title="Beneficiaires" type="titleGreen14" />
                <InputField
                  label={'Nom'}
                  required
                  value={assure.nom}
                  name="nom"
                  onChange={(name: string, value: any, fired: boolean) =>
                    handleChangeAssured(assure.id, name, value, fired)
                  }
                  error={
                    errors.assure?.find(element => element.id === assure.id)
                      ?.nom
                  }
                  showError={
                    showErrors.assure?.find(element => element.id === assure.id)
                      ?.nom
                  }
                  maxLength={70}
                />
                <InputField
                  label={'Prénom'}
                  required
                  value={assure.prenom}
                  name="prenom"
                  onChange={(name: string, value: any, fired: boolean) =>
                    handleChangeAssured(assure.id, name, value, fired)
                  }
                  error={
                    errors.assure?.find(
                      (element: any) => element.id === assure.id,
                    )?.prenom
                  }
                  showError={
                    showErrors.assure?.find(
                      (element: any) => element.id === assure.id,
                    )?.prenom
                  }
                  maxLength={70}
                />
                <InputField
                  label={'Email'}
                  required
                  value={assure.email}
                  name="email"
                  onChange={(name: string, value: any, fired: boolean) =>
                    handleChangeAssured(assure.id, name, value, fired)
                  }
                  error={
                    errors.assure?.find(element => element.id === assure.id)
                      ?.email
                  }
                  showError={
                    showErrors.assure?.find(element => element.id === assure.id)
                      ?.email
                  }
                  maxLength={70}
                />
                <InputPhoneNumber
                  label={'Numéro de Téléphone'}
                  required
                  name="phoneNumber"
                  type="telephone"
                  value={assure.phoneNumber}
                  onChange={(name: string, value: string, fired: any) =>
                    handleChangeAssured(assure.id, name, value, fired)
                  }
                  error={
                    errors.assure.find(
                      (element: any) => element.id === assure.id,
                    )?.phoneNumber
                  }
                  showError={
                    showErrors.assure.find(
                      (element: any) => element.id === assure.id,
                    )?.phoneNumber
                  }
                  country={assure?.countryCode || 'MG'}
                />
                <InputField
                  label={'Numéro Passeport'}
                  required
                  value={assure.passeportNumber}
                  name="passeportNumber"
                  onChange={(name: string, value: any, fired: boolean) =>
                    handleChangeAssured(assure.id, name, value, fired)
                  }
                  error={
                    errors.assure?.find(
                      (element: any) => element.id === assure.id,
                    )?.passeportNumber
                  }
                  showError={
                    showErrors.assure?.find(
                      (element: any) => element.id === assure.id,
                    )?.passeportNumber
                  }
                  maxLength={70}
                />
                {Array.isArray(assure.passeportFile) && (
                  <InputImage
                    style={{justifyContent: 'flex-end'}}
                    label={'Joindre le passeport'}
                    required
                    name="passeportFile"
                    value={assure.passeportFile}
                    onChange={(
                      name: string,
                      value: any,
                      fired: boolean,
                      remove?: boolean,
                    ) =>
                      handleChangeAssured(assure.id, name, value, fired, remove)
                    }
                    error={
                      errors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.passeportFile
                    }
                    showError={
                      showErrors.assure.find(
                        (element: any) => element.id === assure.id,
                      )?.passeportFile
                    }
                    maxLength={1}
                  />
                )}
              </BoxShadowed>
            ))
          : null}
        <View style={{height: 120}} />
      </ScrollView>
      {Platform.OS === 'web' ? <View style={{height: 120}} /> : null}

      <View
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
        }}>
        <SubmitButtons
          style={{marginTop: 0, paddingTop: 10, paddingHorizontal: 20}}
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle={'Valider'}
        />
      </View>
    </View>
  );
};
